export default "__VITE_ASSET__CO0oK$XN__"